<template>
  <div class="document-loan">
    <DocumentTitle activeClass="mb-3">여신거래 정보</DocumentTitle>
    <table>
      <tr>
        <td>여신신청금액</td>
        <td>
          전일 발생한 카드 및 배달앱 매출금에서 수수료를 제외한 금액 (*수수료라 함은 카드사 및
          배달앱 수수료 및 광고대행비용을 통틀어 수수료라 한다.)
        </td>
      </tr>
      <tr>
        <td>변제기간</td>
        <td>
          지급일로부터 5일이내(공휴일인 경우, 익 영업일)
          단, 요기요, 쿠팡이츠 등 배달 매출의 경우 해당 배달 매출
          서비스의 결제 기준을 따른다.
        </td>
      </tr>
      <tr>
        <td>변제방법</td>
        <td>
          각 카드사 및 배달앱 매출(이하 “카드매출대금”) 지급계좌를 채권자가 지정하는 계좌로
          변경하며, 채권자는 해당 지정계좌에 카드매출대금이 지급되는 매 입급일에 상환금액을 비용,
          이자, 원금 순으로 충당
        </td>
      </tr>
      <tr>
        <td>부채증명서 발급 비용</td>
        <td>10,000원</td>
      </tr>
      <tr>
        <td>중도상환수수료</td>
        <td>없음</td>
      </tr>
    </table>
    <v-row no-gutters class="agree mt-3">
      <v-col cols="8">
        <p class="mb-0">여신거래 정보에 대한 내용에</p>
      </v-col>

      <v-col cols="4" class="text-right">
        <button @click="isAgreed = !isAgreed" :class="{ active: isAgreed }">확인함</button>
      </v-col>
    </v-row>

    <v-row no-gutters class="sign-interest-rate">
      <v-col cols="12" v-for="rate in rates" :key="`rate_${rate.type}`" class="rate">
        <p class="rate__title">{{ rate.title }}</p>
        <div class="rate__inputbox">
          <span class="label">연</span>
          <input
            type="text"
            v-model="rate.inputValue"
            @input="checkRate(rate)"
            :class="{ invalid: rate.inputValue && rate.isAgreed == false, active: rate.isAgreed }"
            :ref="`input_${rate.type}`"
            readonly
          />
          <p class="unit">
            <span v-if="rate.isAgreed === false">
              {{ rate.inputValue }}
            </span>
            %
          </p>
        </div>
      </v-col>

      <v-col cols="12">
        <p class="description mb-2">
          계좌이체수수료, 신용조회비용 항목의 금융실비가 발생할수 있으며, 선정산금 지급시 차감한다.
        </p>
        <p class="description mb-2">
          * 이율 계산 방법 - 1년을 365일(윤년은 366일)로 하고 1일 단위로 계산함, 변제기간 경과시 그
          다음날부터 연체이율을 적용함
        </p>
        <p class="caution mb-0">
          * 현행 금융이자 보호에 관한 법률에 따른 최고이자율은 연 20%입니다.
        </p>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import DocumentTitle from '@/components/documents/DocumentTitle.vue'
import { mapActions } from 'vuex'

export default {
  components: {
    DocumentTitle,
  },
  data() {
    return {
      feeSetting: null,
      isAgreed: false,
      rates: [
        {
          title: '정상이율',
          type: 'interest_rate',
          value: 0.07,
          // inputValue: null,
          inputValue: '7.0',
          isAgreed: false,
        },
        {
          title: '연체이율',
          type: 'overdue_interest_rate',
          value: 0.1,
          // inputValue: null,
          inputValue: '10',
          isAgreed: false,
        },
        {
          title: '플랫폼이용수수료율',
          type: 'fee_rate',
          value: 0,
          // inputValue: null,
          inputValue: '0',
          isAgreed: false,
        },
      ],
      dailyFee: 300,
    }
  },
  computed: {
    isAgreedAll() {
      const rateAgreed = this.rates.every((rate) => rate.isAgreed === true)
      return this.isAgreed && rateAgreed
    },
  },
  watch: {
    isAgreedAll(v) {
      this.$emit('emitAgreed', v)
    },
  },
  async created() {
    //:TODO 여기에 이자율을 가져오는 코드를 넣자
    this.feeSetting = await this.getCustomerFeeSettingsCurrent()
    const interestRate = Number(this.feeSetting.interestRate)
    const overdueInterestRate = Math.min(interestRate + 0.03, 0.2)

    const interestRateValue = this.rateFormat(interestRate)
    const overdueInterestRateValue = this.rateFormat(overdueInterestRate)

    this.rates[0].value = interestRateValue.value
    this.rates[0].inputValue = interestRateValue.inputValue
    this.rates[1].value = overdueInterestRateValue.value
    this.rates[1].inputValue = overdueInterestRateValue.inputValue

    // 강제로 체크하는 코드
    this.rates.forEach((rate) => {
      try {
        this.checkRate(rate)
      } catch (e) {}
    })
  },
  methods: {
    ...mapActions('myfinbiz', ['getCustomerFeeSettingsCurrent']),
    rateFormat(v) {
      const value = Number(v.toFixed(4).replace(/0+$/, '').replace(/\.$/, ''))
      const displayValue = (value * 100).toFixed(2).replace(/\.?0+$/, '')
      return {
        value,
        displayValue,
        inputValue: displayValue,
      }
    },
    checkRate(rate) {
      const formatted = this.rateFormat(rate.value)
      rate.isAgreed = formatted.inputValue === rate.inputValue
      // console.log( formatted, rate, rate.isAgreed )

      // if (rate.isAgreed) {
      //   const nextIndex = this.rates.findIndex((rate) => rate.isAgreed === false)
      //   if (nextIndex > -1) {
      //     // this.$refs[`input_${this.rates[nextIndex].type}`][0].focus()
      //   }
      // }
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/common/_variables.scss';

.document-loan {
  table {
    width: 100%;
    border-top: solid 1px #727d8c;
    border-collapse: collapse;

    tr {
      border-bottom: solid 1px #d7e1ea;
      td {
        height: 48px;
      }
      td:first-child {
        width: calc(136% / 325 * 100);
        background-color: #f4faff;
        font-weight: 600;
        font-size: 15px;
        line-height: 2.13;
        text-align: center;
      }
      td:last-child {
        font-size: 14px;
        line-height: 2;
        text-align: left;
        padding: 13px 20px;
        font-size: 16px;
        line-height: 1.38;
        letter-spacing: -0.3px;
      }
    }
  }

  .rate {
    background-color: $white;
    margin-bottom: 20px;

    &__title {
      font-weight: 600;
      margin-bottom: 10px;
    }

    &__inputbox {
      position: relative;
      display: flex;
      align-items: center;

      .label {
        position: absolute;
        margin-left: 15px;
      }

      .unit {
        position: absolute;
        right: 0;

        color: #8a94a2;
        font-weight: 400;

        margin-right: 15px;
        margin-bottom: 0;

        span {
          margin-right: 8px;
        }
      }

      input {
        display: flex;
        align-items: center;

        width: 100%;

        background-color: transparent;
        border-radius: 4px;
        border: solid 1px #d7e1ea;

        color: #333333;
        font-weight: 500;
        line-height: 1;
        text-align: right;

        padding-top: 15px;
        padding-bottom: 15px;
        padding-right: 40px;

        z-index: 10;

        &.active {
          color: $main-color-default;
          border-color: $main-color-default;
          border-width: 2px;
          font-weight: bold;
        }

        &.invalid {
          border: solid 1px $red;
        }
      }
    }
  }

  .caution,
  .description {
    font-size: 15px;
    line-height: 1.53;
    letter-spacing: -0.2px;
    color: #727d8c;
  }
}
</style>
